import React, { Component } from 'react';
import Card from '../Card/Card';
import HorizontalBar from '../HorizontalBar/HorizontalBar';
import OpenSourceList from './OpenSourceList.json';
import classes from './OpenSource.module.css';

class OpenSource extends Component {
  state = {
    patchList: OpenSourceList,
    showPatchList: false
  };

  showPatches = () => {
    const getState = this.state.showPatchList;
    this.setState({ showPatchList: !getState });
  };

  render() {
    const { patchList, showPatchList } = this.state;
    const { history } = this.props;
    const ubootPatches = patchList['U-Boot'].map((patch, index) => {
      return (
        <li className={classes.PatchLink} key={patch.link}>
          {index === 0 ? null : <HorizontalBar />}
          <a href={patch.link} target="_blank" rel="noopener noreferrer">
            <p>{patch.title}</p>
          </a>
        </li>
      );
    });
    return (
      <Card eventTypes="click" goBack={history.goBack} className={classes.OpenSource}>
        <h1>Open Source Contributions</h1>
        <h2 className={classes.OpenSourceProject}>
          <a href="https://github.com/enquirer/enquirer" target="_blank" rel="noopener noreferrer">
            Enquirer (JavaScript)
          </a>
        </h2>
        <p className={classes.OpenSourceDescription}>
          Stylish CLI prompts that are user-friendly, intuitive and easy to create.
        </p>
        <p>
          <a
            href="https://github.com/enquirer/enquirer/pulls?utf8=%E2%9C%93&q=author%3Arajat-sr"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <p className={classes.allpatcheslink}>GitHub - Pull requests</p>
          </a>
        </p>

        <HorizontalBar />
        <h2 className={classes.OpenSourceProject}>
          <a href="https://github.com/u-boot/u-boot" target="_blank" rel="noopener noreferrer">
            U-Boot (C Language)
          </a>
        </h2>
        <p className={classes.OpenSourceDescription}>
          A boot loader for Embedded boards based on PowerPC, ARM, MIPS and several other processors
        </p>

        {showPatchList ? (
          <>
            <p onClick={this.showPatches} className={classes.showpatches}>
              Hide list of patches
            </p>
            <HorizontalBar />
            <ul>{ubootPatches}</ul>
          </>
        ) : (
          <p onClick={this.showPatches} className={classes.showpatches}>
            List of patches
          </p>
        )}
      </Card>
    );
  }
}

export default OpenSource;
